import React, { useContext, useEffect } from "react";

import { AuthContext } from "../../context/auth";

import Menu from './menu';
import TopBar from './top-bar';

export default function Header(props) {
  const { user, isLoggedIn } = useContext(AuthContext);

  function checkAuth() {
    if (isLoggedIn)
      return false;

    return true;
  }
  
  return (
    <>
      <TopBar />
      <Menu />
    </>
  );
}
